<template>
  <div>
    <div class="jumbotron jumbotron-fluid splash">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-6">
            <img src="/static/home-ui.png" style="width:100%" />
          </div>
          <div class="col-12 col-md-6 col-xl-5 title">
            <div class="splash-subtitle">源自清华的 STEAM 教育力作</div>
            <div class="splash-title" style="font-weight:400;margin-top:0.3rem">Neobox<sup>&reg;</sup> LogoUp 3D</div>
            <div class="splash-subtitle" style="font-weight:400;">积木式自由三维设计开放平台</div>
            <div class="splash-hint">点击下面按钮下载最新版本</div>
            <div class="container download-container">
              <div class="row">
                <div class="col-3">
                  <a class="download" target="_blank"
                    v-on:click="download($route.params.source == 'email' ? 'email' : 'windows')">
                    <img src="/static/windows.png" />
                    <div>{{ version }}</div>
                    <span style="white-space:nowrap">Windows 7/8/10</span>
                  </a>
                </div>
                <div class="col-3">
                  <a class="download" target="_blank" v-on:click="download('linux')">
                    <img src="/static/ubuntu.png" />
                    <div>{{ version }}</div>
                    <span style="white-space:nowrap">Ubuntu 12.04+</span>
                  </a>
                </div>
                <!--  <div class="col-3">
                  <a class="download" target="_blank" v-on:click="download('mac')">
                    <img src="/static/apple.png" />
                    <div>{{version}}</div>
                    <span style="white-space:nowrap">MacOSX  10.9+</span>
                  </a>
                </div> 
                -->
                <div class="col-3">
                  <a class="download" target="_blank" data-target="#kirinOptionsModal" data-toggle="modal">
                    <img src="/static/kirin.png" />
                    <div>{{ version }}</div>
                    <span style="white-space:nowrap">国产系统+</span>
                  </a>


                  <div class="modal fade" id="kirinOptionsModal" tabindex="-1" role="dialog"
                    aria-labelledby="kirinOptionsModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="macOptionsModalLabel">LogoUp 3D for 国产系统</h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                            <button class="btn btn-primary btn-block mb-2" style="font-size: 0.9rem;"
                            v-on:click="download('kirinArm')" data-dismiss="modal" >银河麒麟ARM芯片版</button>
                          <button class="btn btn-primary btn-block" style="font-size: 0.9rem;"
                            v-on:click="download('kirinLoongArch')" data-dismiss="modal" >银河麒麟LoongArch芯片版</button>
                            <button class="btn btn-primary btn-block mb-2" style="font-size: 0.9rem;"
                            v-on:click="download('uosArm')" data-dismiss="modal" >统信ARM芯片版</button>
                          <button class="btn btn-primary btn-block" style="font-size: 0.9rem;"
                            v-on:click="download('uosLoongArch')" data-dismiss="modal" >统信LoongArch芯片版</button>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>




                <div class="col-3">
                  <a class="download" target="_blank"  data-toggle="modal"
                    data-target="#macOptionsModal">
                    <img src="/static/apple.png" />
                    <div>{{ version }}</div>
                    <span style="white-space:nowrap">MacOSX</span>
                  </a>


                  <!-- Bootstrap Modal -->
                  <div class="modal fade" id="macOptionsModal" tabindex="-1" role="dialog"
                    aria-labelledby="macOptionsModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="macOptionsModalLabel">LogoUp 3D for MacOS</h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                            <button class="btn btn-primary btn-block mb-2" style="font-size: 0.9rem;"
                            v-on:click="download('macIntel');" data-dismiss="modal">Intel芯片版</button>
                          <button class="btn btn-primary btn-block" style="font-size: 0.9rem;"
                            v-on:click="download('macArm64')" data-dismiss="modal">Apple芯片版</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid multi">
      <span style="white-space:nowrap">
        <div class="bracket">{</div>
        <div class='section'>
          <h3 style='color: #c30'>程序设计</h3>
          <img src='/static/programming.png' />
          <div class='text'>
            培养逻辑思维和程序设计能力<br />
            积木式设计与代码设计自由切换<br />
            可扩展的协作模板库<br />
          </div>
        </div>
        <div class='bracket'>}</div>
      </span>
      <div class='times'>x</div>
      <span style="white-space:nowrap">
        <div class='bracket'>{</div>
        <div class='section'>
          <h3 style='color: #33c'>3D 打印</h3>
          <img src='/static/3d-printing.png' />
          <div class='text'>
            培养动手能力和实操技能<br />
            针对 3D 打印设计的造型语言<br />
            专门适用于构造复杂和自由形体<br />
          </div>
        </div>
        <div class='bracket'>}</div>
      </span>
      <div class='times'>x</div>
      <span style="white-space:nowrap">
        <div class='bracket'>{</div>
        <div class='section'>
          <h3 style='color: #382'>产品创意</h3>
          <img src='/static/design.png' />
          <div class='text'>
            培养创造力和设计能力<br />
            以大量案例为切入点迭代学习<br />
            突出创意设计和协同设计<br />
          </div>
        </div>
        <div class='bracket'>}</div>
      </span>
    </div>
    <div class='jumbotron jumbotron-fluid logoup-overview'>
      <div class="container">
        Neobox<sup>&reg;</sup> LogoUp 3D 是一款采用 <b>积木式编程理念</b> 通过书写程序 来构建三维模型的 <b>三维创新设计平台</b>。
        它适用于 <b>快速构造</b> 面向 3D 打印的 <b>复杂结构</b>、<b>自由形体</b> 和 <b>创意作品</b>，
        其深入浅出的设计理念 可覆盖 从五岁儿童至专业技术人员的 多层次用户，
        因此也适宜于 作为教育教学软件 用于程序设计、三维建模和创造力的培养。
      </div>
    </div>
    <div class='container content-section'>
      <h3>深入浅出<div>积木式 LogoUp 语言是编程教育首选</div>
      </h3>
      <div class="row">
        <div class='text col-12 col-lg-7'>
          <p>
            LogoUp 采用从上世纪 70 年代开始风靡全球教育界的 LOGO 语言 “海龟绘图” 的思想精髓，
            利用命令控制 “小海龟” 的移动，实现图形的绘制。
            LogoUp 将 LOGO 由二维拓展到三维空间，引入现代语法和积木式设计，
            实现专门面向 3D 打印的复杂结构和自由曲面的设计。
            让 LOGO 语言在新时代焕发青春。
          </p>
          <div class='formula'>
            <div class='item'>
              LogoUp<br />
              <span>三维设计语言</span>
            </div>
            <div class='symbol'>=</div>
            <div class='item'>
              Logo<br />
              <span>接近自然语言</span>
            </div>
            <div class='symbol'>+</div>
            <div class='item'>
              Up<br />
              <span>积木式程序设计</span>
            </div>
            <div class='symbol'>+</div>
            <div class='item'>
              CAD<br />
              <span>三维建模功能</span>
            </div>
          </div>
          <p>
            与 LOGO、Snap! 语言相同，
            LogoUp 是一种与自然语言非常接近的编程语言，
            <b>它通过 “绘图” 的方式来学习编程，图形给予了编程直观体验和设计目标，
              适合于对初学者特别是儿童进行寓教于乐的编程教学</b>。
          </p>
        </div>
        <div class="col-12 ml-sm-auto mr-sm-auto col-sm-8 col-lg-5">
          <img src="/static/home-prog-title.png" style="width:100%;margin-top:1rem;margin-bottom:1rem;">
        </div>
      </div>

      <div class="text">
        <p>以下是 LogoUp 语言目前（1.0 版本）支持的语法和功能特性：</p>
        <ol>
          <li>完整支持积木式程序设计（如右图），用户可将命令积木拖拽构成程序；</li>
          <li>支持变量、表达式、判断（IF）、循环（REPEAT）和函数（FUNC）；</li>
          <li>函数作为变量类型可进行传递，闭包特性支持（现代语言）；</li>
          <li>支持三维空间造型，通过拉伸、扫描、回转、布尔运算等灵活方式建模；</li>
          <li>支持递归调用，可实现分形图案和复杂结构的绘制。</li>
        </ol>
        <p>下面给出了一个绘制牟比乌斯圈的例子：</p>
      </div>

      <div class="row code-rect">
        <div class="col-12 col-md-4 col-lg-5 col-xl-4">
          <img src="/static/snapshot-ring.jpg" style="width:100%">
        </div>
        <div class="col-6 col-md-4 col-lg-3 col-xl-4">
          <div class='code' style='display:inline-block;background-color:white;padding:1em;'>
            WIDTH 8<br />
            GO -25<br />
            DRAW<br />
            &nbsp;&nbsp;GO 50<br />
            DONE<br />
            PITCH 90<br />
            <span class='k'>VAR</span> i = 0<br />
            BODY<br />
            &nbsp;&nbsp;<span class='k'>REPEAT</span> 360<br />
            &nbsp;&nbsp;&nbsp;&nbsp;COLOR HSV(i, 60, 100)<br />
            &nbsp;&nbsp;&nbsp;&nbsp;JUMP 2<br />
            &nbsp;&nbsp;&nbsp;&nbsp;YAW 1<br />
            &nbsp;&nbsp;&nbsp;&nbsp;ROLL 1.5<br />
            &nbsp;&nbsp;&nbsp;&nbsp;LINK<br />
            &nbsp;&nbsp;&nbsp;&nbsp;i = i + 1<br />
            &nbsp;&nbsp;<span class='k'>END</span><br />
            DONE<br />
          </div>
        </div>
        <div class="col-6 col-md-4 col-lg-4 col-xl-4" style="background:#f0f0f0;">
          <div class="nl" style='display:inline-block;padding:1em;'>
            设置笔画的宽度为 8 毫米<br />
            向后退 25 毫米<br />
            开始绘制一个笔画<br />
            向前走 50 毫米，绘制一条直线<br />
            结束绘制笔画<br />
            将绘图板（草图）仰起 90 度<br />
            定义名为 i 的变量，设置初始值<br />
            开始绘制一个实体<br />
            将下面至 END 重复执行 360 次<br />
            设置一个漂亮的颜色<br />
            向草图平面的上方跳跃 2 毫米<br />
            水平姿态旋转 1 度（环形旋转）<br />
            绕自身轴旋转 1.5 度（扭曲圈）<br />
            连接上一草图状态，绘制外壁<br />
            将控制颜色的变量 i 增加<br />
            以上语句执行 360 次<br />
            结束实体绘制<br />
          </div>
        </div>
      </div>
    </div>
    <div class='container content-section'>
      <h3>为 3D 打印而生<div>程序式三维建模发挥 3D 打印的最大潜能</div>
      </h3>
      <div class="row">
        <div class='text col-12 col-lg-7'>
          <p>
            采用 LogoUp 构造出的三维几何形状不但先天满足 3D 打印所需的流形、封闭等要求（Maya、3DS 等电影工业建模软件往往不符合），
            相比传统的建模方式，程序式建模更容易构造 <b>复杂的</b>、<b>自由的</b>、<b>参数化的</b> 且 <b>封闭的</b> 实体结构。
          </p>
          <p>下面的几类形体都特别适合 LogoUp 建模：</p>
          <ol>
            <li>具有艺术设计感和流线曲面的形体；</li>
            <li>要求具有封闭、流形（3D 打印）的形体；</li>
            <li>需要进行参数化设计的形体（变量控制整个形体变化）；</li>
            <li>具有重复结构和复杂内部结构的形体；</li>
            <li>传统造型方法难以构造的形体；</li>
            <li>具有分形结构的形体。</li>
          </ol>
        </div>
        <div class="col-12 col-sm-8 mr-sm-auto ml-sm-auto col-lg-5">
          <img src='/static/home-3d-printing-title.png' style='width:100%;margin-top:1rem;margin-bottom:1rem;' />
        </div>
      </div>
      <div class="text">
        <p>
          在模型的表达上，LogoUp 的草图设计支持完整的 <b>参数化建模</b>，可以构造与普通造型软件相同的平面图形；
          其空间建模可以实现 <b>拉伸</b>、<b>扫描</b>、<b>回转</b>、<b>倒角</b> 等等造型特征，
          与普通造型软件在造型能力上等价。
          由于其具有丰富的变换和草图绘制方法，比基于 CSG （实体构造几何）的表达能力强。
        </p>
        <table cellpadding='0' cellspacing='0' style='margin-top:2rem;margin-bottom:1rem;width:100%'>
          <tr>
            <th></th>
            <th>LogoUp 3D</th>
            <th>构造几何（CSG）建模</th>
            <th>特征实体建模</th>
            <th>网格建模</th>
          </tr>
          <tr>
            <th>典型软件</th>
            <td>Neobox<sup>&reg;</sup> LogoUp 3D</td>
            <td>Design Center</td>
            <td>SolidWorks / 3DOne</td>
            <td>Maya / 3DS / SketchUp</td>
          </tr>
          <tr style='background-color:#f8f8f8'>
            <th>3D 打印支持</th>
            <td>
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />封闭实体<br />
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />导出 STL 格式<br />
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />原生薄壳支持<br />
            </td>
            <td>
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />封闭实体<br />
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />导出 STL 格式<br />
              <img src='/static/tick-wrong.png' align='absmiddle' style='margin-right: 1em' />原生薄壳支持 [1]<br />
            </td>
            <td>
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />封闭实体<br />
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />导出 STL 格式<br />
              <img src='/static/tick-wrong.png' align='absmiddle' style='margin-right: 1em' />原生薄壳支持 [1]<br />
            </td>
            <td>
              <img src='/static/tick-wrong.png' align='absmiddle' style='margin-right: 1em' />封闭实体 [2]<br />
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />导出 STL 格式<br />
              <img src='/static/tick-wrong.png' align='absmiddle' style='margin-right: 1em' />原生薄壳支持 [1]<br />
            </td>
          </tr>
          <tr>
            <th>三维造型能力</th>
            <td>
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />参数式建模<br />
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />复杂重复结构<br />
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />分形结构特征<br />
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />复杂曲面设计<br />
            </td>
            <td>
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />参数式建模<br />
              <img src='/static/tick-wrong.png' align='absmiddle' style='margin-right: 1em' />复杂重复结构<br />
              <img src='/static/tick-wrong.png' align='absmiddle' style='margin-right: 1em' />分形结构特征<br />
              <img src='/static/tick-wrong.png' align='absmiddle' style='margin-right: 1em' />复杂曲面设计<br />
            </td>
            <td>
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />参数式建模<br />
              <img src='/static/tick-wrong.png' align='absmiddle' style='margin-right: 1em' />复杂重复结构<br />
              <img src='/static/tick-wrong.png' align='absmiddle' style='margin-right: 1em' />分形结构特征<br />
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />复杂曲面设计<br />
            </td>
            <td>
              <img src='/static/tick-wrong.png' align='absmiddle' style='margin-right: 1em' />参数式建模<br />
              <img src='/static/tick-wrong.png' align='absmiddle' style='margin-right: 1em' />复杂重复结构<br />
              <img src='/static/tick-wrong.png' align='absmiddle' style='margin-right: 1em' />分形结构特征<br />
              <img src='/static/tick-right.png' align='absmiddle' style='margin-right: 1em' />复杂曲面设计<br />
            </td>
          </tr>
          <tr style='background-color:#f8f8f8'>
            <th>教学与门槛</th>
            <td>
              <img src='/static/tick-star.png' align='absmiddle' style='margin-right: 1em' />快速入门<br />
              <img src='/static/tick-star.png' align='absmiddle' style='margin-right: 1em' />渐进式深入学习<br />
            </td>
            <td>
              <img src='/static/tick-star.png' align='absmiddle' style='margin-right: 1em' />快速入门<br />
              <img src='/static/tick-wrong.png' align='absmiddle' style='margin-right: 1em' />渐进式深入学习<br />
            </td>
            <td>
              <img src='/static/tick-wrong.png' align='absmiddle' style='margin-right: 1em' />快速入门<br />
              <img src='/static/tick-star.png' align='absmiddle' style='margin-right: 1em' />渐进式深入学习<br />
            </td>
            <td>
              <img src='/static/tick-wrong.png' align='absmiddle' style='margin-right: 1em' />快速入门<br />
              <img src='/static/tick-star.png' align='absmiddle' style='margin-right: 1em' />渐进式深入学习<br />
            </td>
          </tr>
        </table>
        <div style='font-size:12px;line-height:14px'>
          <p>[1] 无法原生支持专为 3D 打印设置的薄壁结构，需要通过较复杂的形状叠加或抽壳等算法形成薄壁结构；</p>
          <p>[2] Maya / 3DS 等以面片为基准的设计方法无法严格保证生成实体是封闭、流形且无自交；</p>
        </div>
      </div>
    </div>
    <div class='container content-section'>
      <h3>STEAM 教育力作<div>一款软件贯穿程序设计、3D 打印和创意设计</div>
      </h3>
      <div class='text row'>
        <div class="col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2" style="margin-bottom: 1rem;">
          <img src="/static/blocks.png" >
        </div>
        <div class="col-12 col-sm-9 col-md-9 col-lg-10" style="padding-left:1.5rem">
          <h4>程序设计、三维建模互为促进和补充</h4>
          <p>
            程序设计的方法能够帮助三维建模系统更定制化和更灵活地实现三维建模，
            这样的方式更适合发挥 3D 打印的优势，创造出结构复杂、拥有自由曲面和具有功能性的参数化设计。
            三维建模的图形化模式，所见即所得地为程序设计的学习提供了载体和目标，
            通过图形建模和 3D 打印创意设计驱动的程序设计，目的性更强，项目驱动更明确，
            更符合 STEAM 教育的本质。
          </p>
        </div>
        <div class="col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2" style="margin-bottom: 1rem;">
          <img src="/static/bookshelf.png">
        </div>
        <div class="col-12 col-sm-9 col-md-9 col-lg-10" style="padding-left:1.5rem">
          <h4>丰富的课程专为 LogoUp 量身定造</h4>
          <p>
            LogoUp 提供面向教师、工程师和设计师的视频使用教程《LogoUp 程序式三维设计软件 从入门到精通》，
            16 个课时的课程循序渐进地介绍 LogoUp 语言的语法特性、三维建模方法和设计原则。
            LogoUp 向青少年提供基于积木式程序设计的三维建模和 3D 打印整合课程《尼奥博士的实验室》，
            通过 8 个课时深入浅出的案例教学，学习使用了 LogoUp 的设计理念，三维建模和模型设计方法以及培养通过动手实践解决实际问题的能力。
          </p>
        </div>
        <div class="col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2" style="margin-bottom: 1rem;">
          <img src="/static/marty.png">
        </div>
        <div class="col-12 col-sm-9 col-md-9 col-lg-10" style="padding-left:1.5rem">
          <h4>源自清华大学计算机图形学研究所的院士团队</h4>
          <p>
            LogoUp 的研发团队由中国计算机辅助设计的开创者、中国工程院院士孙家广教授领衔，
            其诞生既沿袭了 MIT （麻省理工学院）的优秀科研成果与其覆盖全球的程序教学实践，
            同时也源自于清华大学计算机辅助设计、图形学与可视化研究所卓越的教学和科研团队的丰硕的研究成果，
            其代表着国际先进的 STEAM 理念、计算机辅助设计技术和强大的纵深衍生能力。
          </p>
        </div>
      </div>
    </div>
     <div class='container content-section'>
      <h3>Neobox® LogoUp 3D <div>软件价格</div>
      </h3>
      <div class='text row'>
        <div class="col-6 ml-auto mr-auto col-sm-3 col-md-3 col-lg-2" style="margin-bottom: 1rem;">
          <img src="/static/logoup-512.png"  style="width: 158px;height: 128px;">
        </div>
        <div class="col-12 col-sm-9 col-md-9 col-lg-10" style="padding-left:1.5rem">
          <!-- <h4>软件定价方案</h4> -->
 <p><b></br>一年期授权
798元  

初级用户选择，灵活体验核心功能</br>

三年期授权
3980元 功能更全面，适用多种应用场景，专业用户/稳定项目最佳选择</br>


终身版授权
7980元
一次付费，永久使用，享最高级别服务
免除续费烦恼，永久合作伙伴!</b></p>

        
        </div>
     
      </div>
    </div>
    <div class='content-section'>&nbsp;<br />&nbsp;<br /></div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      version: '',

      downloadUrls: {},
    };
  },
  methods: {
  
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 760px) {

  /* Force table to not be like tables anymore */
  table,
  thead,
  tbody,
  th,
  td,
  tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr {
    border: 1px solid #ccc;
  }

  td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
    font-size: 0.7rem;
  }

  td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
  }

  /*
Label the data
*/
  td:nth-of-type(1):before {
    content: "LogoUp 3D";
  }

  td:nth-of-type(2):before {
    content: "构造几何（CSG）建模";
  }

  td:nth-of-type(3):before {
    content: "特征实体建模";
  }

  td:nth-of-type(4):before {
    content: "网格建模";
  }

  table tr:first-child {
    display: none;
  }

  table>tr>th {
    padding: 0.8em 1em;
    border-bottom: solid 1px #ccc;
    color: #f84;
    font-size: 18px;
    text-align: left;
  }
}

@media (min-width: 100px) {
  .splash .title {
    padding-top: 1rem;
  }

  .splash-title {
    font-size: 7vw;
  }

  .splash-subtitle {
    font-size: 5vw;
  }

  .splash-hint {
    font-size: 4vw;
    margin-top: 1rem;
    margin-bottom: 0.8rem
  }

  .splash .download {
    padding: 0.4rem 0.4rem;
    font-size: 0;
  }

  .multi .section {
    display: block;
  }

  .multi .bracket {
    display: none;
  }

  .multi .times {
    display: none;
  }

  .formula .item {
    font-size: 2.4vw;
  }

  .formula .symbol {
    font-size: 2.4vw;
  }

  .formula span {
    font-size: 1.6vw;
  }

  .code {
    font-size: 2.1vw;
    line-height: 1rem;
  }

  .nl {
    font-size: 2.1vw;
    line-height: 1rem;
  }
}

@media (min-width: 768px) {
  .splash .title {
    padding-top: 3rem;
  }

  .splash-title {
    font-size: 1.5rem;
  }

  .splash-subtitle {
    font-size: 1.2rem;
  }

  .splash-hint {
    font-size: 1rem;
  }

  .splash .download {
    padding: 1rem 0.2rem;
    font-size: 0.5rem;
  }

  .multi .section {
    display: inline-block;
  }

  .multi .section .text {
    font-size: 1.4vw;
  }

  .multi .section img {
    width: 12vw;
    max-width: 128px;
  }

  .multi .bracket {
    display: inline-block;
  }

  .multi .times {
    display: inline-block;
  }

  .code {
    font-size: 0.9vw;
    line-height: 0.8rem;
  }

  .nl {
    font-size: 0.9vw;
    line-height: 0.8rem;
  }

  table td {
    padding: 0.5em 1em;
    font-size: 16px;
  }
}

@media (min-width: 992px) {
  .splash-title {
    font-size: 2rem;
  }

  .splash-subtitle {
    font-size: 1.5rem;
  }

  .splash-hint {
    font-size: 1rem;
    margin-top: 3rem;
    margin-bottom: 0.8rem
  }

  .splash .download {
    font-size: 0.6rem;
  }

  .formula .item {
    font-size: 1.4vw;
  }

  .formula .symbol {
    font-size: 1.8vw;
  }

  .formula span {
    font-size: 0.9vw;
  }

  .code {
    font-size: 1.1vw;
    line-height: 1.3rem;
  }

  .nl {
    font-size: 1.1vw;
    line-height: 1.3rem;
  }
}

.splash {
  background-color: #1886dd;
  background-image: url(/static/home-bg.jpg);
  transition: background 1s;
  background-position: center;
}

.splash .title {
  display: inline-block;
  padding-right: 2rem;
  color: white;
  text-shadow: 2px 2px 3px #0078d7;
  font-weight: 100;
  text-align: right;
}

.download-container {
  max-width: 560px;
  float: right;
}

.splash .download {
  display: inline-block;
  background: white;
  text-shadow: none;
  box-shadow: 2px 2px 3px 3px #0078d7;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  text-align: center;
}

.splash .download img {
  width: 75%;
  margin-bottom: 5px
}

.splash .download:hover {
  background: #f0f0f0;
}

.multi {
  text-align: center;
}

.multi .section {
  padding-top: 1rem;
  padding-bottom: 1rem;
  text-align: center;
  vertical-align: middle;
}

.multi .section h3 {
  font-size: 24px;
  font-weight: 100;
}

.multi .section .text {
  margin-top: 1em;
  font-weight: 100;
}

.multi .bracket {
  color: #ddd;
  font-weight: 100;
  font-size: 6.5vw;
  vertical-align: middle;
}

.multi .times {
  color: #ddd;
  font-size: 3vw;
  vertical-align: middle;
}

.jumbotron .logoup-overview {
  background: #f0f0f0;
  line-height: 32px;
  font-size: 18px;
  font-weight: 100;
}

.logoup-overview b {
  color: #0078d7;
}

.row.code-rect div {
  padding: 0;
}

.code-rect {
  border-radius: 16px;
  border: solid 1px #ccc;
  overflow: hidden;
  margin-bottom: 1.5rem;
}

.code {
  font-family: Courier;
  font-weight: bold;
}

.code .k {
  font-weight: bold;
  color: #00f;
}

.code .n {
  color: #c00;
}

.formula {
  vertical-align: middle;
  text-align: center;
  margin-top: 2em;
  margin-bottom: 2em;
}

.formula .item {
  display: inline-block;
  border-radius: 8px;
  border: solid 1px #ccc;
  padding: 10px;
  text-align: center;
  vertical-align: middle;
  background-color: #f84;
  color: white;
}

.formula .symbol {
  display: inline-block;
  vertical-align: middle;
  font-weight: 400;
}

table>tr:first-child>th {
  padding: 0.8em 1em;
  border-bottom: solid 1px #ccc;
  color: #f84;
  font-size: 18px;
  text-align: left;
}

table td {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue